import { useState, useRef } from 'react';
import api from '../../lib/api';
import { Button } from '../ui/button';
import { Upload, X, Loader2, Image as ImageIcon } from 'lucide-react';

export function ImageUpload({ value, onChange, folder = "uploads", className = "" }) {
  const [uploading, setUploading] = useState(false);
  const [preview, setPreview] = useState(value || '');
  const inputRef = useRef(null);

  async function handleFile(e) {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!file.type.startsWith('image/')) return;
    setUploading(true);
    try {
      // Get signature from backend
      const { data: sig } = await api.get(`/admin/cloudinary/signature?folder=${folder}`);
      // Upload directly to Cloudinary
      const form = new FormData();
      form.append('file', file);
      form.append('api_key', sig.api_key);
      form.append('timestamp', sig.timestamp);
      form.append('signature', sig.signature);
      form.append('folder', sig.folder);
      const res = await fetch(`https://api.cloudinary.com/v1_1/${sig.cloud_name}/image/upload`, { method: 'POST', body: form });
      const result = await res.json();
      if (result.secure_url) {
        setPreview(result.secure_url);
        onChange(result.secure_url);
      }
    } catch (err) {
      console.error('Upload failed:', err);
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = '';
    }
  }

  function handleRemove() {
    setPreview('');
    onChange('');
  }

  return (
    <div className={className}>
      <input ref={inputRef} type="file" accept="image/*" onChange={handleFile} className="hidden" data-testid="image-upload-input" />
      {preview ? (
        <div className="relative group inline-block">
          <img src={preview} alt="Upload" className="w-full max-w-[200px] h-32 object-cover rounded-lg border border-zinc-200" />
          <button onClick={handleRemove} className="absolute top-1 right-1 w-6 h-6 bg-red-500 text-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity" data-testid="remove-image-btn">
            <X size={12} />
          </button>
        </div>
      ) : (
        <Button type="button" variant="outline" onClick={() => inputRef.current?.click()} disabled={uploading} className="h-32 w-full max-w-[200px] border-dashed border-2 flex flex-col items-center justify-center gap-2" data-testid="upload-image-btn">
          {uploading ? <Loader2 size={20} className="animate-spin text-[#7551e8]" /> : <Upload size={20} className="text-zinc-400" />}
          <span className="text-xs text-zinc-500">{uploading ? 'Uploading...' : 'Upload Image'}</span>
        </Button>
      )}
    </div>
  );
}
